module.exports = __webpack_public_path__ + "img/00_KV.2f63e503.png";